import { render } from "./SubCommentForm.vue?vue&type=template&id=677eb6f8"
import script from "./SubCommentForm.vue?vue&type=script&lang=js"
export * from "./SubCommentForm.vue?vue&type=script&lang=js"

import "./SubCommentForm.vue?vue&type=style&index=0&id=677eb6f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__